import { GetReminderQuery } from "@/api/hasura/generated/graphql"
import { useQuery, useMutation } from "@/api/utils/useQuery"
import { QueryResult } from "@/api/utils/types"
import { HasuraQueries } from "@/api/hasura/queries"
import { HasuraMutations } from "@/api/hasura/mutations"

export interface IReminder {
  active: boolean
}

const parseMeterReadRemindersQuery = (data?: GetReminderQuery): IReminder[] => {
  if (!data) return []

  return data.reminder
}
class MeterReminderServiceServiceClass {
  getForAccount(accountNumber: string): QueryResult<IReminder[]> {
    return useQuery({
      ...HasuraQueries.comms.meterReminder(accountNumber),
      useRawResponse: true,
      parserFn: (rawData: GetReminderQuery) =>
        parseMeterReadRemindersQuery(rawData),
    })
  }

  toggleForAccount() {
    return useMutation({
      ...HasuraMutations.comms.updateMeterReminder(),
      invalidateCache: true,
      serializerFn: (data) => data,
    })
  }
}

export const MeterReminderService = new MeterReminderServiceServiceClass()
